type FeatureFlagValue = 0 | 1;

type FeatureFlagsState = {
  quoteUploadCopperWireTables: FeatureFlagValue;
};

// Developer-controlled defaults. Change 0/1 here as needed.
const featureFlagsState: FeatureFlagsState = {
  quoteUploadCopperWireTables: 1,
};

const toFeatureFlagValue = (value: unknown): FeatureFlagValue => {
  if (value === 1 || value === "1" || value === true || value === "true") {
    return 1;
  }

  return 0;
};

export const setFeatureFlagsFromApi = (flags: {
  quoteUploadCopperWireTables?: unknown;
}) => {
  if (flags.quoteUploadCopperWireTables !== undefined) {
    featureFlagsState.quoteUploadCopperWireTables = toFeatureFlagValue(
      flags.quoteUploadCopperWireTables,
    );
  }
};

export const FEATURE_FLAGS = {
  get quoteUploadCopperWireTables() {
    return featureFlagsState.quoteUploadCopperWireTables === 1;
  },
};
